import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { config } from 'utils/config';
import {
  StyledContent,
  StyledFooter,
  StyledIrregularBoxContainer
} from './JuniorsFooter.styled';
import { getPublicPath } from 'utils/paths';
import {} from 'components/shared/accordion/Accordion.styled';

const JuniorsFooter: React.FC = () => {
  const { t } = useI18n('helping-companies');
  const { locale } = useRouter();

  return (
    <StyledFooter>
      <StyledIrregularBoxContainer
        $src={getPublicPath(`/images/helpingCompanies/irregular-box-white.svg`)}
      >
        <StyledContent>
          <Heading2 alignLeft>{t('helping-companies.footer.title')}</Heading2>
          <p>
            <Trans
              ns={'helping-companies'}
              i18nKey={'helping-companies.footer.desc'}
              components={{
                mailToSupportLink: <a href={`mailto:${config.supportEmail}`} />
              }}
            ></Trans>
          </p>
          <ButtonLink
            href={`${getAppUrl(
              APP_URLS.hrAsAService,
              locale
            )}?locale=${locale}&source=footer-helping-companies`}
            variant="brandCompany"
            onClick={(e) =>
              ServiceEventTracking.trackExternalLandingCtaClicked(
                e,
                `${getAppUrl(
                  APP_URLS.hrAsAService,
                  locale
                )}?locale=${locale}&source=footer-helping-companies`,
                'footer-helping-companies'
              )
            }
          >
            <span>{t('helping-companies.footer.cta')}</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </ButtonLink>
        </StyledContent>
      </StyledIrregularBoxContainer>
    </StyledFooter>
  );
};

export default JuniorsFooter;
